import { useState, useEffect } from 'react';
import { List, Datagrid, TextField, useRecordContext, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField, FunctionField } from 'react-admin';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { timestampToStrDate } from '../utils/utils';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const OrderList = (props) => {
    var record = useRecordContext();
    const dataProvider = useDataProvider();
    const [orders, setOrders] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {

        if(record != undefined){
            var id = record.clientId;
            if(record.hasOwnProperty("clientId"))
                id = record.clientId;
            dataProvider.getList('users/'+id+"/orders", {
                pagination: { page: 1, perPage: 999999 },
                sort: { field: 'id', order: 'ASC' },
                filter: {  },
            })
            .then(({ data }) => {
                setOrders(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
        }
            
    }, [record]);

    if (loading) return <CircularProgress style={{margin: "auto"}} color="inherit" />;
    if (error) return <Typography variant="h6" color="red">Erreur lors du chargement des commandes</Typography>;
    if (!orders) return null;

    if(orders.length == 0) return <Typography variant="h6" color="inherit">Aucune commande enregistrée.</Typography>;

    return (
        <div style={{width: "100%"}}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Date de commande</TableCell>
                        <TableCell>Date de retrait demandée</TableCell>
                        <TableCell>Date de retour demandée</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {orders.map((order) => (
                        <TableRow
                        key={order.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                <a href={"/#/orders/"+order.id}>{order.id}</a>
                            </TableCell>
                            <TableCell>{timestampToStrDate(order.creationDate)}</TableCell>
                            <TableCell>{timestampToStrDate(order.pickUpDate)}</TableCell>
                            <TableCell>{timestampToStrDate(order.deliveredDate)}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
};